import {
  initialState,
  Actions,
  State,
  GET_ALL_MODULES,
  GET_ALL_MODULES_SUCCESS,
  GET_ALL_MODULES_ERROR,
  UPDATE_CURRENT_MODULES,
} from "../../types/module/all-modules";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case GET_ALL_MODULES:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case GET_ALL_MODULES_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case GET_ALL_MODULES_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: false,
          error: action.payload,
          success: false,
        },
      };
    case UPDATE_CURRENT_MODULES:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: false,
        },
      };
    default:
      return state;
  }
};

export default reducers;
